import React from "react"
import { TextareaAutosize } from "@mui/material"
import { createUseStyles } from 'react-jss'

const useStyles = createUseStyles({
    textarea: {
        resize: 'none',
        paddingTop: '4px',
        paddingBottom: '4px',
        borderRadius: '4px',
        borderColor: 'lightgray',
        '&::placeholder': {
            textAlign: 'center'
        }
    }
})

const TextArea = (props) => {
    const styles = useStyles();
    const {type, name, value, isList, maxRows} = props
    const valuePresent = value ? true : false
    var normalizedName = name.substring(name.indexOf("[") + 1, name.indexOf("]"))

    const defaultValue = (value) => {
        if (valuePresent) {
            return isList ? value.join('\n') : value;
        } else {
            return "";
        }
    }

    const defaultHeight = (value) => {
        if (valuePresent) {
            return isList ? value.length : 1;
        } else {
            return 1;
        }
    }

    return (
        <TextareaAutosize
          className={styles.textarea}
          rows={defaultHeight(value)}
          type={type}
          name={name}
          placeholder={`Enter ${normalizedName} here`}
          defaultValue={defaultValue(value)}
          maxRows={maxRows ? maxRows : ''}/>
    );
}

export default TextArea
